import React, { FC } from "react";

import MaterialChip, { ChipProps } from "@mui/material/Chip";

export const Chip: FC<ChipProps> = props => <MaterialChip {...props} />;